import { Component, OnInit } from '@angular/core';
import { ITransaction, Transaction } from '../../../../models/transaction.model';
import { Order } from '../../../../models/order.model';
import { OrderService } from '../../../../services/order.service';
import { UserService } from '../../../../services/user.service';
import { Router } from '@angular/router';
import { AuthService } from '../../../../services/auth.service';
import { DatePipe } from '@angular/common';
import Swal from 'sweetalert2';
import * as XLSX from "xlsx";
import { environment } from '../../../../environments/environment';
import { INote, Note } from '../../../../models/avis.model';
import { NoteService } from '../../../../services/note.service';
import { ProductService } from '../../../../services/product.service';
import { Product } from '../../../../models/product.model';
@Component({
  selector: 'app-notes',
  templateUrl: './notes.component.html',
  styleUrls: ['./notes.component.scss']
})
export class NotesComponent implements OnInit {
  beginDate: any = null;
  endDate: any = null;
  notesPotes: INote[] = [];
  allNotesPostesTmp: INote[] = [];
  notesSellers: INote[] = [];
  allNotesSellersTmp: INote[] = [];
  search: any;
  page = 1;
  perPage = 10;
  sorted = 1;
  sorted2 = false;
  url_photo: String;
  notePostsDefaultDisplay = false;
  noteSellerDisplayed = false;
  // @ts-ignore
  currentPostNote: INote = [];
    // @ts-ignore
  currentSellerNote: INote = [];

  currentOrder: Order;

  constructor(private noteService: NoteService,
              private orderService: OrderService,
              private authService: AuthService, private router: Router,
              private datePipe: DatePipe,private productService: ProductService) { }

  ngOnInit(): void {
    this.authService.isAuthenticated().subscribe(isAuthenticated => {
      this.notePostsDefaultDisplay = true;
      this.loadKahpooPostesNotes();
      this.loadKahpooSellersNotes();
    },error=>{
      this.router.navigate(['/login']);
    });
    this.url_photo = environment.url_photo;
  }

  getStars(note: number): boolean[] {
    const stars = [false, false, false, false, false];
    for (let i = 0; i < note; i++) {
      stars[i] = true;
    }
    return stars;
  }

  // showFull = false;
  showFullComment(note:any) {
    note.showFull = !note.showFull;
  }

  disableEndDate = true;
  displayError = false;
  //Récupération de la date de début
  getBeginDate(event:any){
    this.beginDate=event.target.value;
    if(this.beginDate){
      this.disableEndDate = false;
      if(this.beginDate > this.endDate){
        this.displayError = true;
      }else{
        this.displayError = false;
      }
    }else{
      this.disableEndDate = true;
    }
  }

  // Récupération de la date de fin
  getEndDate(event){
    this.endDate=event.target.value;
  }

  loadKahpooPostesNotes = () =>{
    this.noteService.loadNotePoste().subscribe(data => {
      this.notesPotes = data;
      //console.log("🌴🌴🌴🌴🌴🌴🌴🌴🌴🌹🌹🌹  For Posts 🌹🌹🌹🌴🌴🌴🌴🌴🌴🌴🌴🌴")
     // console.log(this.notesPotes)
     // console.log("🌴🌴🌴🌴🌴🌴🌴🌴🌴🌹🌹🌹  End for Post 🌹🌹🌹🌴🌴🌴🌴🌴🌴🌴🌴🌴")
      this.allNotesPostesTmp = this.notesPotes;
      // console.log("Liste de tous les transactions");
      // console.log(this.allTransactionsTmp);
    })
  };

  loadKahpooSellersNotes = () =>{
    this.noteService.loadNoteSeller().subscribe(data => {
      this.notesSellers = data;
      // console.log("🌴🌴🌴🌴🌴🌴🌴🌴🌴🌹🌹🌹  For Sellers 🌹🌹🌹🌴🌴🌴🌴🌴🌴🌴🌴🌴")
      // console.log(this.notesSellers)
      // console.log("🌴🌴🌴🌴🌴🌴🌴🌴🌴🌹🌹🌹  End for seller 🌹🌹🌹🌴🌴🌴🌴🌴🌴🌴🌴🌴")
      this.allNotesSellersTmp = this.notesSellers;
      // console.log("Liste de tous les transactions");
      // console.log(this.allTransactionsTmp);
    })
  };

  displayPerPage(value: any) {
    this.perPage = parseInt(value, 10);
    // console.log(this.perPage);
  }

  filterNotesPostByRating(selectedRating: number) {
    if (selectedRating < 1 || selectedRating > 5) {
      this.notesPotes = this.allNotesPostesTmp;
      return;
    }
    this.notesPotes = this.allNotesPostesTmp.filter(value => value.note === Number(selectedRating));
  }

  searchFilter($event: KeyboardEvent) {
    // console.log(this.search);
    this.search = this.search.toString().toLowerCase();
    this.notesPotes = this.allNotesPostesTmp;
    this.notesPotes = this.notesPotes.filter(value =>
      value.article?.toUpperCase().includes(this.search)  || value.article?.toLowerCase().includes(this.search)
      || value.category?.name?.toUpperCase().includes(this.search) || value.category?.name?.toLowerCase().includes(this.search)
      || value?.lastname?.toUpperCase().includes(this.search) || value?.lastname?.toLowerCase().includes(this.search)
      || value?.firstname?.toUpperCase().includes(this.search) || value?.firstname?.toLowerCase().includes(this.search)
      || value?.sellerFirstname?.toUpperCase().includes(this.search) || value?.sellerFirstname?.toLowerCase().includes(this.search)
      || value?.sellerLastname?.toUpperCase().includes(this.search) || value?.sellerLastname?.toLowerCase().includes(this.search)
      || value?.sellerUsername?.toUpperCase().includes(this.search) || value?.sellerUsername?.toLowerCase().includes(this.search)
      || value?.createdAt.toString()?.toUpperCase().includes(this.search) || value?.createdAt.toString()?.toLowerCase().includes(this.search)
      || value.note===this.search
      || value?.comment?.toUpperCase().includes(this.search) || value?.comment?.toLowerCase().includes(this.search)
    );
  }


  filterNotesSellerByRating(selectedRating: number) {
    if (selectedRating < 1 || selectedRating > 5) {
      this.notesSellers = this.allNotesSellersTmp;
      return;
    }
    this.notesSellers = this.allNotesSellersTmp.filter(value => value.note === Number(selectedRating));
  }

  searchFilter1($event: KeyboardEvent) {
    // console.log(this.allNotesSellersTmp);
    this.search = this.search.toString().toLowerCase();
    this.notesSellers = this.allNotesSellersTmp;
    this.notesSellers = this.notesSellers.filter(value =>
      value?.lastname?.toUpperCase().includes(this.search) || value?.lastname?.toLowerCase().includes(this.search)
      || value?.firstname?.toUpperCase().includes(this.search) || value?.firstname?.toLowerCase().includes(this.search)
      || value?.sellerFirstname?.toUpperCase().includes(this.search) || value?.sellerFirstname?.toLowerCase().includes(this.search)
      || value?.sellerLastname?.toUpperCase().includes(this.search) || value?.sellerLastname?.toLowerCase().includes(this.search)
      || value?.sellerUsername?.toUpperCase().includes(this.search) || value?.sellerUsername?.toLowerCase().includes(this.search)
      || value?.createdAt.toString()?.toUpperCase().includes(this.search) || value?.createdAt.toString()?.toLowerCase().includes(this.search)
      || value.note===this.search
      || value?.comment?.toUpperCase().includes(this.search) || value?.comment?.toLowerCase().includes(this.search)
    );
  }

  selectTransactionStatus(value: any) {
    if(value=="achat"){
      this.notePostsDefaultDisplay = true;
      this.noteSellerDisplayed = false;
    }
    if(value=="vendeur"){
      this.notePostsDefaultDisplay = false;
      this.noteSellerDisplayed = true;
    }
  }
  currentNote = false;
  product: Product;
  onViewNotePost(note: any) {
    this.currentNote= note;
    // console.log(note);
    this.noteService.findNotesByIdPost(note.id).subscribe(notePost =>  {
      this.currentPostNote = notePost;
      this.productService.getProductbyProductId(this.currentPostNote?.post?.postSubProducts[0]?.subProduct?.productID).subscribe(rs =>{
        this.product = rs;
        // console.log("Détails produitttt.....");
        // console.log(this.product);
      })
      // console.log("Détails notePoste.....");
      // console.log(this.currentPostNote);
    });
  }

  exportexcel(fileName): void {
    /* table id is passed over here */
    let element = document.getElementById('excel-table');
    const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, fileName);

  }

  filterkahpooNotes() {
    if (this.endDate == null || this.beginDate== null) {
      Swal.fire({
        position: 'top-end',
        icon: 'error',
        title: 'Veuillez choisir une date de début et une date de fin s\'il vous plaît',
        showConfirmButton: false,
        timer: 3500
      })
      return;
    }
    if (this.endDate!= null && this.beginDate!= null && this.beginDate <= this.endDate) {
      const dateString = this.endDate;
      const date = new Date(dateString);
      date.setDate(date.getDate() + 1); // ajoute 1 jour à la date
      this.endDate = this.datePipe.transform(date,'yyyy-MM-dd');
      this.notesPotes = this.allNotesPostesTmp;
      this.notesPotes = this.notesPotes.filter((t) => {
        return (this.beginDate == null || t.createdAt >= this.beginDate) &&
          (this.endDate == null || t.createdAt <= this.endDate);
      });
    }
  }

  filterkahpooNotes1() {
    if (this.endDate == null || this.beginDate== null) {
      Swal.fire({
        position: 'top-end',
        icon: 'error',
        title: 'Veuillez choisir une date de début et une date de fin s\'il vous plaît',
        showConfirmButton: false,
        timer: 3500
      })
      return;
    }
    if (this.endDate!= null && this.beginDate!= null && this.beginDate <= this.endDate) {
      const dateString = this.endDate;
      const date = new Date(dateString);
      date.setDate(date.getDate() + 1); // ajoute 1 jour à la date
      this.endDate = this.datePipe.transform(date,'yyyy-MM-dd');
      this.notesSellers = this.allNotesSellersTmp;
      this.notesSellers = this.notesSellers.filter((t) => {
        return (this.beginDate == null || t.createdAt >= this.beginDate) &&
          (this.endDate == null || t.createdAt <= this.endDate);
      });
    }
  }

  resetFilter() {
    this.loadKahpooPostesNotes();
    this.beginDate = null;
    this.endDate = null;
  }

  resetFilter1() {
    this.loadKahpooSellersNotes();
    this.beginDate = null;
    this.endDate = null;
  }

  trier(columnName: keyof Note) {
    this.sorted = -this.sorted;
    this.notesPotes.sort((a, b) => a[columnName] > b[columnName] ? this.sorted : -this.sorted);
  }

  trier1(columnName: keyof Note) {
    this.sorted = -this.sorted;
    this.notesSellers.sort((a, b) => a[columnName] > b[columnName] ? this.sorted : -this.sorted);
  }

  sort2() {
    if (this.sorted2 == false) {
      // @ts-ignore
      this.notesPotes.sort((a, b) => a?.category?.name > b?.category?.name ? 1 : a?.category?.name < b?.category?.name ? -1 : 0);
      this.sorted2 = true;
    } else {
      // @ts-ignore
      this.notesPotes.sort((a, b) => a?.category?.name < b?.category?.name ? 1 : a?.category?.name > b?.category?.name ? -1 : 0);
      this.sorted2 = false;
    }
  }

  deleteNotePost(note: INote){
    Swal.fire({
      title: 'Voulez-vous vraiment supprimer cette note ?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonText: 'Non',
      confirmButtonText: 'Oui'
    }).then((result) => {
      if (result.isConfirmed) {
        this.noteService.deleteNote(note.id).subscribe(
          rs=> {
            this.reloadComponent();
            Swal.fire({
              position: 'top-end',
              icon: 'success',
              title: 'Note supprimée avec succès.',
              showConfirmButton: false,
              timer: 1500
            });
            this.loadKahpooPostesNotes();
          }, error => {
            // console.log(error);
            Swal.fire({
              position: 'top-end',
              icon: 'error',
              title: error.error.errorMessage,
              showConfirmButton: false,
              timer: 1500
            })
          }
        )
      }
    })
  }

  deleteNoteSeller(note: INote){
    Swal.fire({
      title: 'Voulez-vous vraiment supprimer cette note ?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonText: 'Non',
      confirmButtonText: 'Oui'
    }).then((result) => {
      if (result.isConfirmed) {
        this.noteService.deleteNoteVendeur(note.id).subscribe(
          rs=> {
            this.reloadComponent();
            Swal.fire({
              position: 'top-end',
              icon: 'success',
              title: 'Note supprimée avec succès.',
              showConfirmButton: false,
              timer: 1500
            });
            this.loadKahpooPostesNotes();
          }, error => {
            // console.log(error);
            Swal.fire({
              position: 'top-end',
              icon: 'error',
              title: error.error.errorMessage,
              showConfirmButton: false,
              timer: 1500
            })
          }
        )
      }
    })
  }

  reloadComponent() {
    let currentUrl = this.router.url;
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate([currentUrl]);
  }

}
